var render = function render(_c, _vm) {
  return _c(
    "div",
    {
      staticClass:
        "top-alert-box top-alert-box-primary top-alert-box--solid-bg p-l-20 p-r-20 slide-down slide-down--medium-duration",
      class: _vm.props.customClass
    },
    [
      _c("div", { staticClass: "top-alert-box__message text-left" }, [
        _c("div", { staticClass: "top-alert-box__title" }, [
          _vm._v("\n      " + _vm._s(_vm.props.primaryMessage) + "\n      "),
          _c("span", { staticClass: "top-alert-box__title-sup" }, [
            _vm._v("\n        " + _vm._s(_vm.props.superScript) + "\n      ")
          ])
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "top-alert-box__sub-title" }, [
          _vm._v("\n      " + _vm._s(_vm.props.subMessage) + "\n    ")
        ])
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-secondary m-l-40",
          class: _vm.props.customButtonClass,
          on: { click: _vm.props.openPage }
        },
        [_vm._v("\n    Get Started\n  ")]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "top-alert-box__close",
          on: {
            click: function($event) {
              return _vm.props.closeBanner()
            }
          }
        },
        [_c("i", { staticClass: "fa fa-times" })]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }